






















































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {
  },
  data() {
    return {overlay: false,
    info: [
        {
          lesson: 'Anthrax PEP Dispensing and Smallpox Vaccination:  Due to the acute nature of a bioterrorism attack, a timely public health response is required to minimize negative health outcomes.  In accordance with Cities Readiness Initiative (CRI), the goal is to provide PEP to the affected population within 48 hours of the decision to do so.  There is no explicit objective for completing Smallpox vaccination.  San Francisco, for example, has a goal to complete smallpox vaccination to its population in 5 days.',
          consideration: 'Unlike Smallpox vaccination, the availability of COVID-19 vaccines and the ongoing nature of the pandemic results in a longer vaccination timeline.  In this analysis, we examine the personnel needs for administering 100 million or 200 million COVID-19 vaccination in 100 days.  Because of the longer timeline for COVID-19 vaccination, the personnel requirements are reduced for COVID-19.',
        },
        {
          lesson: 'Anthrax PEP Dispensing:  The number of personnel needed to staff points of distribution (PODs) for post-exposure prophylaxis (PEP) varies greatly from city to city.  Some cities minimize personnel needs and require 60-70 people per shift while other cities may require 150-200 people per shift.',
          consideration: 'Likely to be similar for COVID-19 vaccination - we expect variability in the number of personnel needed to staff vaccination clinics from city to city.  ',
        },
        {
          lesson: 'Anthrax PEP Dispensing and Smallpox Vaccination:  Anthrax PEP dispensing is likely to involve non-medical PODs where the majority of people staffing the PODs are non-medical volunteers with some public health and medical involvement.  Smallpox vaccination requires staff with medical backgrounds.',
          consideration: 'Similar to Smallpox vaccination, administering COVID-19 vaccines requires staff with medical backgrounds who are qualified to administer vaccines.  ',
        },
        {
          lesson: 'Smallpox Vaccination Exercises:  In addition to the people who administer vaccines, there are many other people required to ensure effective operations within the vaccination center.  This includes people involved in triage, fever/symptom checkers, medical screening, etc. ',
          consideration: 'Similar to Smallpox vaccination, COVID-19 vaccination will need to rely on many people in the vaccination clinic an addition to the people administering the vaccines.',
        },
        {
          lesson: 'Vaccination Throughput:  San Francisco Smallpox exercise accomplished a throughput rate of 20 people vaccinated per vaccination station per hour.  CDC guidelines (Annex 3) assume a throughput of  approximately 30-60 people per hour per vaccination station.  In a New Jersey vaccination exercise, they found that non-medically trained health department staff (trained by nurses) could give approximately 33 vaccinations per hour.  Their experience is that vaccinating children would be closer to 15 vaccinations per hour.',
          consideration: 'Vaccination Throughput:  San Francisco Smallpox exercise accomplished a throughput rate of 20 people vaccinated per vaccination station per hour.  CDC guidelines (Annex 3) assume a throughput of  approximately 30-60 people per hour per vaccination station.  In a New Jersey vaccination exercise, they found that non-medically trained health department staff (trained by nurses) could give approximately 33 vaccinations per hour.  Their experience is that vaccinating children would be closer to 15 vaccinations per hour.	The vaccination throughput is influenced by the structure of the vaccination clinic and the effectiveness of staff involved in other locations of the vaccination clinic.  The CDC guidelines of 30-60 people vaccinated per hour per vaccination station may be optimistic given observed exercise throughputs of 20 per hour (San Francisco), 33 per hour (New Jersey), and 15 per hour for vaccinations involving children.',
        },
      ],
    }
  },
  created() {
    this.$store.dispatch("setRoute", "methodology");
  },
  computed: {
    ...mapState(['copyDisplay'])
  },
  methods: {
    setBenefits() {
      this.$store.dispatch("setCopyDisplay", "benefits");
    },
    setPersonnel() {
      this.$store.dispatch("setCopyDisplay", "personnel");
    }
  },
  mounted() {
    this.$store.dispatch("setHref", this.$router.currentRoute.path);
  }
}
)
export default class Home extends Vue {}
